import { Chip } from '@/components/ui'
import type { CofaStatus } from '../api/types'

const STATUS_LABEL: Record<CofaStatus, string> = {
  complete: 'Complete',
  missing_spi: 'Missing SPI',
  missing_vendor: 'Missing vendor',
}

const STATUS_VARIANT: Record<CofaStatus, 'success' | 'warning' | 'danger'> = {
  complete: 'success',
  missing_spi: 'warning',
  missing_vendor: 'danger',
}

export function DocumentStatusChip({
  status,
  size = 'xs',
}: {
  status: CofaStatus
  size?: 'xs' | 'md'
}) {
  return (
    <Chip size={size} variant={STATUS_VARIANT[status]} dot>
      {STATUS_LABEL[status]}
    </Chip>
  )
}
